//const EntityHome = () => import(/* webpackChunkName: "entityHome" */ '@/components/EntityHome')
const routes = [
    {
        path: '/encounters',
        component: () => import('@/pages/encounter/EncounterHome.vue'),
        meta: { breadCrumb: 'Encounter', entity: 'encounter' },
        children: [
            {
                path: '',
                name: 'encounter',
                component: () => import('@/pages/encounter/EncounterList.vue'),
            },
            {
                path: 'filter/:eventId?/:teamId?',
                name: 'filterEncounter',
                component: () => import('@/pages/encounter/EncounterList.vue'),
                props: true,
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'timetable/:eventId?/:teamId?',
                name: 'encounterTimeTable',
                component: () => import('@/pages/encounter/EncounterTimetable.vue'),
                meta: { breadCrumb: 'Timetable' },
                props: true,
            },
            {
                path: 'archive',
                name: 'encounterArchive',
                component: () => import('@/pages/encounter/EncounterArchive.vue'),
                meta: { breadCrumb: 'Archive' },
            },
            {
                path: 'new',
                name: 'newEncounter',
                component: () => import('@/pages/encounter/EncounterEditor.vue'),
                props: route => ({
                    ...route.params,
                }),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editEncounter',
                component: () => import('@/pages/encounter/EncounterEditor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/copy',
                name: 'copyEncounter',
                component: () => import('@/pages/encounter/EncounterEditor.vue'),
                props: route => ({ id: route.params.id, copy: true }),
                meta: { breadCrumb: 'Copy' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readEncounter',
                component: () => import('@/pages/encounter/EncounterReader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
            {
                path: 'print',
                name: 'encounterPrint',
                component: () => import('@/pages/encounter/EncounterPrint.vue'),
                meta: { breadCrumb: 'Print' },
            },
        ],
    },
]

export default routes
